export const predefinedFields = {
    email: "email",
    repeatEmail: "repeatEmail",
    firstName: "firstName",
    lastName: "lastName",
    phone: "phone",
    availability: "availability",
    cvFiles: "cvFiles",
    country: "country",
    region: "region",
    city: "city",
    street: "street",
    homeNumber: "homeNumber",
    postalCode: "postalCode",
    apartmentNumber: "apartmentNumber",
    expectedSalary: "expectedSalary",
    TextBox: "TextBox",
    languages: "languages",
    drivingLicense: "drivingLicense",
    clauses: "clauses",
    recommendingPerson: "recommendingPerson",
} as const;
